export default {
    name: 'VerificationDivider'
};
